<template>
    <b-container>
        <b-row>
            <!-- Left content and breadcrumb -->
            <b-col
                cols="12"
                md="8"
                class="p-0">
                <b-card class="card-main-article">
                    <!-- breadcrumb-->
                    <b-breadcrumb class="m-0">
                        <b-link
                            @click="routeToName('home')">
                            <i class="fas fa-less-than"></i>
                            Home
                        </b-link>
                    </b-breadcrumb>
                    <!-- Content -->
                    <b-container class="p-4">
                        <b-card-title
                            title-tag="h3">
                            {{ linkTitle }}
                        </b-card-title>
                        <div
                            v-if="linkContent != null && linkContent != ''"
                            v-html="linkContent">
                        </div>
                        <b-alert
                            v-else
                            show
                            variant="warning">
                            This content is missing or empty! Please contact the site administrator.
                        </b-alert>
                    </b-container>
                </b-card>
            </b-col>
            <!-- Right links card -->
            <b-col
                cols="12"
                md="4"
                class="p-0">
                <b-card
                    no-body
                    class="card-sidebar">
                    <news-content-card
                        v-if="linkCardTitle == 'News'"
                        :news-card-title="linkCardTitle"
                        :news-card-bundle="linkCardBundle"/>
                    <links-content-card
                        v-else
                        :link-card-title="linkCardTitle"
                        :link-card-bundle="linkCardBundle"/>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import LandingContentBaseComponent from './LandingContentBaseComponent.vue';

const contentBundle = 'Secondary Pages';

export default {
    name: 'SecondaryLandingContent',
    extends: LandingContentBaseComponent,
    props: {
        linkCardTitle: {
            type: String,
            required: true,
            default: 'Default Title'
        },
        linkCardBundle: {
            type: String,
            required: true,
            default: 'DefaultContentPath'
        },
        linkTitle: {
            type: String,
            required: true,
            default: 'Default Link Text Title'
        },
        linkContentItem: {
            type: String,
            required: true,
            default: 'DefaultLinkContentItem'
        }
    },
    data() {
        return {linkContent: 'Loading...'};
    },
    watch: {
        linkContentItem: function () {
            this.linkContent = this.getContent(contentBundle, this.linkContentItem);
        }
    },
    mounted() {
        this.initializeContent().then(() => {
            const content = this.getContent(contentBundle, this.linkContentItem);
            this.linkContent = content;
        });
    },
    methods: { }
};
</script>
